import { getAwaitGambleAction } from 'automaton/actions/AwaitGambleAction'
import { getDelayAction } from 'automaton/actions/DelayAction'
import { getRequestGambleAction } from 'automaton/actions/RequestGambleAction'
import { getBetState } from 'automaton/states/BetState'

export function getGambleState() {
  const name = 'GAMBLE'
  const actions = [
    getRequestGambleAction(),
    game.models.GameModel.requestAgainAllowed
      ? getDelayAction(0.1)
      : getAwaitGambleAction(),
  ]
  const transition = () => getBetState()

  return {
    name,
    actions,
    transition,
  }
}
